import { useState } from 'react'
import { useLang } from '_metronic/i18n/Metronici18n'

interface Props {
	isUseDateFilter?: boolean
	filter?: any
	onChangeDateFilter?: (
		type: 'today' | 'thisWeek' | 'thisMonth' | 'custom',
		key?: string,
		value?: any
	) => void
}

const ActiveComponent = () => {
	return (
		<span className="d-inline-block bg-kumopack-success-500 p-1 rounded-circle w-2px h-2px me-1" />
	)
}

const DateFilterToolbar: React.FC<Props> = ({ isUseDateFilter = true, onChangeDateFilter }) => {
	const lang = useLang()
	const [activeTab, setActiveTab] = useState<'today' | 'this week' | 'this month' | 'custom'>(
		'today'
	)

	const handleTabClick = (tab: 'today' | 'this week' | 'this month' | 'custom') => {
		setActiveTab(tab)
	}

	return (
		<div className="w-fit-content">
			<div className="kumopack-button-group">
				<button
					className="btn btn-sm white-button text-kumopack-grey-700 fw-bold left"
					onClick={() => {
						handleTabClick('today')
						if (onChangeDateFilter) onChangeDateFilter('today')
					}}>
					{isUseDateFilter && activeTab === 'today' && <ActiveComponent />}{' '}
					{lang === 'en' ? 'Today' : 'วันนี้'}
				</button>
				<button
					className="btn btn-sm white-button text-kumopack-grey-700 fw-bold middle"
					onClick={() => {
						handleTabClick('this week')
						if (onChangeDateFilter) onChangeDateFilter('thisWeek')
					}}>
					{isUseDateFilter && activeTab === 'this week' && <ActiveComponent />}
					{lang === 'en' ? 'This Week' : 'สัปดาห์นี้'}
				</button>
				<button
					className="d-none d-xl-block btn btn-sm white-button text-kumopack-grey-700 fw-bold right"
					onClick={() => {
						handleTabClick('this month')
						if (onChangeDateFilter) onChangeDateFilter('thisMonth')
					}}>
					{isUseDateFilter && activeTab === 'this month' && <ActiveComponent />}
					{lang === 'en' ? 'This Month' : 'เดือนนี้'}
				</button>
				{/* <button
					className="btn btn-sm white-button text-kumopack-grey-700 fw-bold right"
					onClick={() => handleTabClick('custom')}>
					{activeTab === 'custom' && <ActiveComponent />}
					<img
						className="me-1 d-none d-xl-inline-block h-15px"
						src="/media/icons/kumopack/plus.svg"
						alt="Grey Plus Icon"
					/>
					Custom
				</button> */}
			</div>
		</div>
	)
}

export default DateFilterToolbar
